const frameBrowser = {
  frameBrowserHeader: 'Here you can see where',
  frameBrowserHeader2: 'your frames are in the work.',
  yourFrames: 'Your Frames',
  claimFrame: 'Claim Frame'
};

module.exports = frameBrowser;
